import Model from "./Model";

export default class FichaIndividualCAee extends Model {
  constructor(data) {
    super();
    Object.assign(this, data);
  }
}
